// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"dam-6"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 3H20V21H15V15C15 13.3431 13.6569 12 12 12V12C10.3431 12 9 13.3431 9 15V21H4V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 21H3M4 21H9M4 21V3H20V21M20 21H21M20 21H15M9 21H10M9 21V15C9 13.3431 10.3431 12 12 12V12C13.6569 12 15 13.3431 15 15V21M14 21H15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 8H4H9H15H20H21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-dam-6')
export default class Dam6Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-6',
    }
  }
}
